import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cms-show-more',
  templateUrl: './cms-show-more.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CmsShowMoreComponent {}
